import { EmailStudioMode } from '@conversed/shared/src/central/types/email-studio.type';
import { z } from 'zod';

export const EmailStudioSettingsSchema = z.object({
  selectedBlockId: z.string().nullable(),
  mode: z.nativeEnum(EmailStudioMode),
  mailbox: z.email().nullable(),
  tenantId: z.uuid().optional(),
});

export const EmailStudioSettingsResponseSchema = z.object({
  selectedBlockId: z.string().nullable().optional(),
  mode: z.nativeEnum(EmailStudioMode).optional(),
  mailbox: z.email().nullable().optional(),
  tenantId: z.uuid().optional(),
});

export type TEmailStudioSettings = z.infer<typeof EmailStudioSettingsSchema>;
